import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class TimezonesService {

  constructor(
    public http: HttpClient
  ) { }


  getRegionToTimezones() {
    return this.http.get('assets/data/state-timezones.json')
  }


  getAvailableTimezones() {
    return this.http.get('assets/data/timezones.json')
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/timezones.service.ts